function getUid(elementIdPrefix = "") {
  return `${elementIdPrefix}${Math.random().toString(16).substring(2, 10)}`;
}
export {
  getUid as g
};
